import LabCallsV2 from "./v2/LabCalls";

export default function LabCalls(props) {
  return <LabCallsV2 {...props} />;
}
